module.exports = __webpack_public_path__ + "fonts/23272fd.woff";